import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import {
    FaArrowLeft, FaShoppingCart, FaMoneyBillWave, FaQrcode, FaTrash,
    FaPlus, FaMinus, FaMotorcycle, FaCheckCircle,
    FaUtensils, FaLock, FaUserCircle, FaSearch, FaGift, FaPhone,
    FaTruckLoading, FaTimes, FaHamburger, FaEdit, FaClipboardList,
    FaCalculator, FaPrint, FaHistory, FaArrowRight, FaCashRegister, FaFileInvoice
} from 'react-icons/fa';

const SUCURSAL_CONFIG = {
    1: { nombre: 'COMO EN CASA', color: 'linear-gradient(135deg, #D32F2F 0%, #B71C1C 100%)', primary: '#D32F2F' },
    2: { nombre: 'YUM YUM SC1', color: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)', primary: '#FF9800' },
    3: { nombre: 'YUM YUM SC2', color: 'linear-gradient(135deg, #FFC107 0%, #FFB300 100%)', primary: '#FFC107' }
};

const API_URL = 'https://api.alquilacarbolivia.com/api';

export default function Ventas({ sucursalId, user, goBack }) {
    const currentSucursal = SUCURSAL_CONFIG[parseInt(sucursalId)] || { nombre: 'PUNTO DE VENTA', color: '#333', primary: '#333' };
    
    // Clave única para guardar el ticket por sucursal
    const STORAGE_KEY = `ultimoVentaId_${sucursalId}`;

    // ==============================================================================
    // 1. ESTADOS
    // ==============================================================================
    const [turno, setTurno] = useState(null);
    const [productos, setProductos] = useState([]);
    const [carrito, setCarrito] = useState([]);
    const [clientesDb, setClientesDb] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    
    // Cargar el último ticket SOLO de esta sucursal
    const [ultimoTicketId, setUltimoTicketId] = useState(localStorage.getItem(STORAGE_KEY));

    const [showModalProducto, setShowModalProducto] = useState(false);
    const [showPago, setShowPago] = useState(false);
    const [showEntregar, setShowEntregar] = useState(false);
    const [pedidosPendientes, setPedidosPendientes] = useState([]);

    const [stepMixta, setStepMixta] = useState(1); 
    const [m1Seleccionada, setM1Seleccionada] = useState(null);
    const [m1Excluidos, setM1Excluidos] = useState([]);
    const [m2Seleccionada, setM2Seleccionada] = useState(null);
    const [m2Excluidos, setM2Excluidos] = useState([]);
    const [m1Receta, setM1Receta] = useState([]);
    const [m2Receta, setM2Receta] = useState([]);

    const [prodSeleccionado, setProdSeleccionado] = useState(null);
    const [mixtalExcluidos, setMixtalExcluidos] = useState([]);
    const [observacionProducto, setObservacionProducto] = useState('');
    const [ingredientesExcluidos, setIngredientesExcluidos] = useState([]);
    const [recetaActual, setRecetaActual] = useState([]);

    const [cliente, setCliente] = useState({ nombre: '', telefono: '' });
    const [clienteIdDb, setClienteIdDb] = useState(null);
    const [esPedidosYa, setEsPedidosYa] = useState(false);
    const [codigoPY, setCodigoPY] = useState('');
    const [tipoPago, setTipoPago] = useState('efectivo');
    const [montoEfectivo, setMontoEfectivo] = useState('');
    const [montoQR, setMontoQR] = useState('');
    const [cambio, setCambio] = useState(0);
    const [descuento, setDescuento] = useState({ tipo: 'ninguno', valor: 0, motivo: '' });
const [ventaFinalizadaId, setVentaFinalizadaId] = useState(null);
    const [showFactura, setShowFactura] = useState(false);
    const [facturaData, setFacturaData] = useState({ razon_social: '', nit: '' });

    // ==============================================================================
    // 2. FUNCIONES DE LÓGICA
    // ==============================================================================

    const checkTurno = async () => {
        try {
            const res = await axios.get(`${API_URL}/caja/estado?usuario_id=${user.id}&sucursal_id=${sucursalId}`);
            if (res.data.estado === 'abierto') setTurno(res.data.turno);
            else setTurno(false);
        } catch (error) { setTurno(false); }
    };

    const fetchProductos = async () => {
        try {
            const res = await axios.get(`${API_URL}/productos/${sucursalId}`);
            setProductos(res.data);
        } catch (error) { console.error(error); }
    };

    const fetchClientes = async () => {
        try {
            const res = await axios.get(`${API_URL}/clientes`);
            setClientesDb(res.data);
        } catch (error) { console.error(error); }
    };

    const fetchPedidosPendientes = async () => {
        try {
            const res = await axios.get(`${API_URL}/monitor/${sucursalId}`);
            setPedidosPendientes(res.data.filter(p => p.estado_pedido !== 'entregado'));
        } catch (error) { setPedidosPendientes([]); }
    };

    const handleImpresion = async (tipo, id) => {
        if (!id) {
            Swal.fire('Info', 'No hay ventas recientes en esta sucursal para reimprimir.', 'info');
            return;
        }
        try {
            const ruta = tipo === 'reporte-cierre' ? 'caja/reporte-cierre' : `ventas/${tipo}`;
            const res = await axios.get(`${API_URL}/${ruta}/${id}`);
            if (res.data && res.data.pdfUrl) {
                window.open(`https://api.alquilacarbolivia.com${res.data.pdfUrl}`, '_blank');
            }
        } catch (e) { Swal.fire('Error', 'No se pudo generar el documento', 'error'); }
    };

    const handleAbrirTurno = async () => {
        const { value: m } = await Swal.fire({ 
            title: 'Apertura de Caja', 
            html: '<p>Ingrese el monto inicial en efectivo:</p>',
            input: 'number', inputPlaceholder: 'Ej: 100.00', confirmButtonColor: '#28a745', showCancelButton: true
        });
        if(m) { 
            try {
                await axios.post(`${API_URL}/caja/abrir`, {usuario_id: user.id, sucursal_id: sucursalId, monto_inicial: m}); 
                checkTurno(); 
            } catch (e) { Swal.fire('Error', 'No se pudo abrir caja', 'error'); }
        }
    };

    const handleCerrarTurno = async () => {
        const { value: m } = await Swal.fire({ 
            title: 'Cierre de Caja', 
            html: '<p class="text-danger">⚠️ Ingresa el total contado en caja (cierre ciego):</p>',
            input: 'number', inputPlaceholder: '0.00', confirmButtonColor: '#dc3545', showCancelButton: true
        });
        if(m !== undefined) { 
            try {
                await axios.post(`${API_URL}/caja/cerrar`, {id: turno.id, monto_final: m});
                handleImpresion('reporte-cierre', turno.id);
                setTurno(false); 
            } catch (e) { Swal.fire('Error', 'No se pudo cerrar caja', 'error'); }
        }
    };

    const handleNuevaVenta = () => {
        setVentaFinalizadaId(null);
        setShowPago(false); 
        setCarrito([]);
        setCliente({ nombre: '', telefono: '' });
        setClienteIdDb(null);
        setDescuento({ tipo: 'ninguno', valor: 0, motivo: '' });
        setEsPedidosYa(false);
        setCodigoPY('');
        setMontoEfectivo('');
        setMontoQR('');
        setTipoPago('efectivo');
setFacturaData({ razon_social: '', nit: '' });
    };

    const handleProductoClick = async (prod) => {
        setProdSeleccionado(prod);
        setStepMixta(1);
        setM1Seleccionada(null); setM2Seleccionada(null);
        setM1Excluidos([]); setM2Excluidos([]);
        setObservacionProducto('');
        setIngredientesExcluidos([]);
        setRecetaActual([]);

        if (!prod.nombre.toLowerCase().includes('mixta')) {
            try {
                const res = await axios.get(`${API_URL}/recetas/${prod.id}`);
                setRecetaActual(res.data);
            } catch (e) { setRecetaActual([]); }
        }
        setShowModalProducto(true);
    };

    const fetchRecetaWizard = async (nombreMilanesa) => {
        const prod = productos.find(p => p.nombre === nombreMilanesa);
        if (prod) {
            try {
                const res = await axios.get(`${API_URL}/recetas/${prod.id}`);
                setRecetaActual(res.data);
            } catch (e) { setRecetaActual([]); }
        }
    };

    const confirmarAgregarProducto = () => {
        const esMixta = prodSeleccionado.nombre.toLowerCase().includes('mixta');
        const precioBase = parseFloat(prodSeleccionado.precio);

        let item = {
            ...prodSeleccionado,
            cartItemId: Date.now(),
            precioOriginal: precioBase,
            cantidad: 1,
            subtotal: precioBase,
            observacion: observacionProducto,
        };

        if (esMixta) {
            const detM1 = `${m1Seleccionada}${m1Excluidos.length ? ' (SIN: ' + m1Excluidos.join(', ') + ')' : ''}`;
            const detM2 = `${m2Seleccionada}${m2Excluidos.length ? ' (SIN: ' + m2Excluidos.join(', ') + ')' : ''}`;
            item.nombreDisplay = `MILANESA MIXTA:\n - ${detM1}\n - ${detM2}`;
            item.ingredientesExcluidos = {
                m1: m1Seleccionada,
                m1_excluidos: m1Excluidos,
                m2: m2Seleccionada,
                m2_excluidos: m2Excluidos
            };
        } else {
            item.nombreDisplay = prodSeleccionado.nombre;
            item.ingredientesExcluidos = ingredientesExcluidos;
        }

        setCarrito([...carrito, item]);
        setShowModalProducto(false);
    };

    const calcularTotal = () => {
        const sub = carrito.reduce((acc, i) => acc + i.subtotal, 0);
        const extraPY = esPedidosYa ? (carrito.length * 10) : 0;
        let d = 0;
        const totalBruto = sub + extraPY;
        if(descuento.tipo === 'porcentaje') d = totalBruto * (descuento.valor / 100);
        if(descuento.tipo === 'fijo' || descuento.tipo === 'puntos') d = parseFloat(descuento.valor);
        return Math.max(0, totalBruto - d);
    };

    const handleAplicarDescuento = async () => {
        const opciones = clientesDb.map(c => `<option value="${c.id}">${c.nombre} (Pts: ${c.puntos || 0})</option>`).join('');
        const { value: fv } = await Swal.fire({
            title: 'Descuento / Fidelidad',
            html: `<div class="text-start">
                <label class="small fw-bold">1. Cliente *</label>
                <select id="sw-cli" class="form-select mb-2"><option value="">-- Seleccionar --</option>${opciones}</select>
                <label class="small fw-bold">2. Tipo</label>
                <select id="sw-tipo" class="form-select mb-2">
                    <option value="puntos">Canjear Puntos (1=1Bs)</option>
                    <option value="fijo">Monto Fijo (Bs)</option>
                    <option value="porcentaje">Porcentaje (%)</option>
                </select>
                <label class="small fw-bold">3. Valor</label>
                <input id="sw-val" type="number" class="form-control mb-2">
                <label class="small fw-bold">4. Motivo / Observación</label>
                <input id="sw-motivo" type="text" class="form-control" placeholder="Ej: Atención lenta, cumple...">
            </div>`,
            showCancelButton: true,
            preConfirm: () => {
                const cliId = document.getElementById('sw-cli').value;
                const val = document.getElementById('sw-val').value;
                if(!cliId || !val) return Swal.showValidationMessage('Complete los campos');
                return { cliId, tipo: document.getElementById('sw-tipo').value, valor: val, motivo: document.getElementById('sw-motivo').value };
            }
        });

        if (fv) {
            const cli = clientesDb.find(c => c.id.toString() === fv.cliId);
            if (fv.tipo === 'puntos' && parseFloat(fv.valor) > (cli.puntos || 0)) return Swal.fire('Error', 'Puntos insuficientes', 'error');
            setCliente({ nombre: cli.nombre, telefono: cli.telefono });
            setClienteIdDb(cli.id);
            setDescuento({ tipo: fv.tipo, valor: fv.valor, motivo: fv.motivo || 'Descuento' });
        }
    };

    const handleFinalizarVenta = async () => {
        const totalFinal = calcularTotal();
        const recargoPY = esPedidosYa ? 10 : 0;
        const totalItems = carrito.length;

        const subtotalConPY = (carrito.reduce((a,b)=>a+b.subtotal,0)) + (totalItems * recargoPY);
        let montoDsctoBs = 0;
        if(descuento.tipo === 'porcentaje') montoDsctoBs = subtotalConPY * (descuento.valor / 100);
        else montoDsctoBs = parseFloat(descuento.valor);

        try {
            const ventaData = {
                turno_id: turno.id,
                sucursal_id: sucursalId,
                cliente_nombre: cliente.nombre || 'Público General',
                cliente_telefono: cliente.telefono,
                total: totalFinal,
                metodo_pago: esPedidosYa ? `pedidosya | COD: ${codigoPY}` : (tipoPago === 'mixto' ? `mixto | E:${montoEfectivo} Q:${montoQR}` : tipoPago),
                productos: carrito.map(i => ({
                    ...i, 
                    nombre: i.nombreDisplay,
                    precio: i.precioOriginal + recargoPY, 
                    cantidad: i.cantidad,
                    subtotal: (i.precioOriginal + recargoPY) * i.cantidad,
                    observacion: i.observacion, 
                    ingredientes_excluidos: i.nombreDisplay.includes('Mixta') ? JSON.stringify({m1: i.m1Excluidos, m2: i.m2Excluidos}) : JSON.stringify(i.ingredientesExcluidos)
                })),
descuento_data: { tipo: descuento.tipo, cantidad: montoDsctoBs, motivo: descuento.motivo, cliente_id: clienteIdDb },
factura_razon_social: facturaData.razon_social || null,
factura_nit: facturaData.nit || null
            };
            const res = await axios.post(`${API_URL}/ventas`, ventaData);
            
            // GUARDAR EL ID ASOCIADO A ESTA SUCURSAL
            setVentaFinalizadaId(res.data.venta_id);
            setUltimoTicketId(res.data.venta_id);
            localStorage.setItem(STORAGE_KEY, res.data.venta_id); // <--- Clave específica por sucursal
            
            fetchPedidosPendientes();
        } catch (e) { Swal.fire('Error', 'No se pudo registrar', 'error'); }
    };

    // --- CARGAS Y EFECTOS ---
    useEffect(() => {
        checkTurno(); 
        fetchProductos(); 
        fetchClientes(); 
        fetchPedidosPendientes();
        // Al cambiar de sucursal, actualizar el ID del último ticket guardado para ESA sucursal
        setUltimoTicketId(localStorage.getItem(STORAGE_KEY)); 
    }, [sucursalId]);

    useEffect(() => {
        const total = calcularTotal();
        const efec = parseFloat(montoEfectivo) || 0;
        const qr = parseFloat(montoQR) || 0;
        setCambio(tipoPago === 'mixto' ? (efec + qr) - total : efec - total);
    }, [montoEfectivo, montoQR, carrito, descuento, tipoPago, esPedidosYa]);

    // ==============================================================================
    // 3. RENDERS BLOQUEANTES
    // ==============================================================================
    if (ventaFinalizadaId) return (
        <div className="vh-100 d-flex flex-column align-items-center justify-content-center bg-white text-center">
            <FaCheckCircle size={80} className="text-success mb-3"/>
            <h2 className="fw-bold">VENTA COMPLETADA #{ventaFinalizadaId}</h2>
            <div className="d-grid gap-3 mt-4" style={{width:'300px'}}>
                <button className="btn btn-warning btn-lg fw-bold py-3 shadow" onClick={()=>handleImpresion('comanda', ventaFinalizadaId)}><FaUtensils className="me-2"/> COMANDA COCINA</button>
                <button className="btn btn-success btn-lg fw-bold py-3 shadow" onClick={()=>handleImpresion('recibo', ventaFinalizadaId)}><FaPrint className="me-2"/> RECIBO CLIENTE</button>
                <button className="btn btn-dark btn-lg mt-2 shadow" onClick={handleNuevaVenta}><FaPlus className="me-2"/> NUEVA VENTA</button>
            </div>
        </div>
    );

    if (turno === false) return (
        <div className="vh-100 d-flex flex-column align-items-center justify-content-center text-white" style={{background:'#1a1d21'}}>
            <div className="mb-4 d-flex align-items-center justify-content-center" style={{background:'rgba(255,193,7,0.1)', width:100, height:100, borderRadius:'50%'}}><FaLock size={50} className="text-warning"/></div>
            <h1 className="fw-bold mb-1">CAJA CERRADA</h1>
            <p className="text-secondary mb-5">Debe abrir un turno para comenzar a operar</p>
            <div className="d-flex gap-3">
                <button className="btn btn-outline-light px-4 py-2 fw-bold" onClick={goBack} style={{borderRadius:'12px'}}><FaArrowLeft/> VOLVER</button>
                <button className="btn btn-success px-4 py-2 fw-bold" onClick={handleAbrirTurno} style={{borderRadius:'12px', background:'#2ecc71', border:'none'}}><FaCashRegister/> ABRIR TURNO</button>
            </div>
        </div>
    );

    if (!turno) return <div className="vh-100 d-flex align-items-center justify-content-center">Cargando...</div>;

    // ==============================================================================
    // 4. RENDER PRINCIPAL (ORDEN NORMAL)
    // ==============================================================================
    return (
        <div className="vh-100 d-flex flex-column bg-light">
            <div className="px-3 py-2 d-flex justify-content-between align-items-center text-white shadow-sm" style={{ background: currentSucursal.color }}>
                <div className="d-flex align-items-center gap-3">
                    <button className="btn btn-light rounded-circle shadow-sm" onClick={goBack} style={{width:40, height:40}}><FaArrowLeft/></button>
                    <div><h6 className="m-0 fw-bold">{currentSucursal.nombre}</h6><small>{user.nombre}</small></div>
                </div>
                <div className="d-flex gap-2">
                    <button className="btn btn-info btn-sm text-white fw-bold rounded-pill px-3 shadow-sm" onClick={()=>handleImpresion('recibo', ultimoTicketId)}><FaHistory/> Reimprimir</button>
                    <button className="btn btn-warning btn-sm fw-bold rounded-pill px-3 shadow-sm" onClick={()=>setShowEntregar(true)}><FaTruckLoading/> Pendientes ({pedidosPendientes.length})</button>
                    <button className="btn btn-danger btn-sm rounded-circle" onClick={handleCerrarTurno}><FaLock/></button>
                </div>
            </div>

            <div className="flex-grow-1 overflow-hidden">
                <div className="row h-100 g-0">
                    <div className="col h-100 d-flex flex-column p-3">
                        <input className="form-control mb-3 border-0 shadow-sm py-2" placeholder="🔍 Buscar platillo..." onChange={e=>setSearchTerm(e.target.value)}/>
                        <div className="flex-grow-1 overflow-auto">
                            <div className="row g-3">
                                {productos.filter(p=>p.nombre.toLowerCase().includes(searchTerm.toLowerCase())).sort((a, b) => {const letraA = a.nombre.charAt(0).toUpperCase();const letraB = b.nombre.charAt(0).toUpperCase();if (letraA === 'M' && letraB !== 'M') return -1;if (letraA !== 'M' && letraB === 'M') return 1;if (letraA === 'E' && letraB !== 'E' && letraB !== 'M') return -1;if (letraA !== 'E' && letraB === 'E' && letraA !== 'M') return 1;return a.nombre.localeCompare(b.nombre);}).map(p => (
                                    <div key={p.id} className="col-6 col-md-4 col-xl-3">
                                        <div className="card h-100 border-0 shadow-sm" onClick={()=>handleProductoClick(p)} style={{borderRadius:'15px', cursor:'pointer'}}>
                                            <div className="card-body text-center p-2">
                                                <div className="bg-light rounded mb-2 d-flex align-items-center justify-content-center" style={{height:'80px'}}>
                                                    {p.imagen_url ? <img src={p.imagen_url} className="h-100 w-100 object-fit-cover rounded" alt=""/> : <FaHamburger size={30} className="text-muted opacity-25"/>}
                                                </div>
                                                <h6 className="fw-bold m-0 small">{p.nombre}</h6>
                                                <span className="text-success fw-bold small">Bs. {parseFloat(p.precio).toFixed(2)}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-xl-3 bg-white h-100 border-start d-flex flex-column shadow">
                        <div className="p-3 text-white fw-bold d-flex justify-content-between align-items-center" style={{ background: currentSucursal.primary }}>
                            <span>ORDEN ACTUAL</span>
                            <button className={`btn btn-sm ${esPedidosYa?'btn-danger':'btn-outline-light'}`} onClick={async ()=>{
                                if(esPedidosYa){ setEsPedidosYa(false); setCodigoPY(''); }
                                else {
                                    const {value: c} = await Swal.fire({title:'Pedidos Ya', input:'text', inputLabel:'Código'});
                                    if(c){ setEsPedidosYa(true); setCodigoPY(c); }
                                }
                            }}><FaMotorcycle/></button>
                        </div>
                        {esPedidosYa && <div className="bg-danger text-white text-center py-1 small fw-bold">MODO PEDIDOS YA: {codigoPY} (+10 Bs/Plato)</div>}
                        {descuento.tipo !== 'ninguno' && (
                            <div className="bg-warning text-dark text-center py-1 small fw-bold border-bottom">
                                DESCUENTO: {descuento.motivo.toUpperCase()} (- Bs. {(carrito.reduce((a,b)=>a+b.subtotal,0) + (esPedidosYa?carrito.length*10:0) - calcularTotal()).toFixed(2)})
                            </div>
                        )}
                        <div className="flex-grow-1 overflow-auto p-2">
                            {carrito.map(item => (
                                <div key={item.cartItemId} className="card border-0 bg-light mb-2 shadow-sm">
                                    <div className="card-body p-2">
                                        <div className="fw-bold small" style={{whiteSpace:'pre-line'}}>{item.nombreDisplay}</div>
                                        {item.observacion && <div className="text-muted x-small mt-1 italic"><FaEdit/> {item.observacion}</div>}
                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                            <div className="btn-group btn-group-sm">
                                                <button className="btn btn-white border" onClick={()=>setCarrito(carrito.map(i=>i.cartItemId===item.cartItemId?{...i, cantidad:Math.max(1, i.cantidad-1), subtotal:(Math.max(1,i.cantidad-1))*i.precioOriginal}:i))}>-</button>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    max="999"
                                                    className="form-control form-control-sm text-center fw-bold border"
                                                    style={{width: '60px', borderRadius: 0}}
                                                    value={item.cantidad}
                                                    onFocus={e=>e.target.select()}
                                                    onChange={e=>{
                                                        const n = Math.min(999, Math.max(1, parseInt(e.target.value) || 1));
                                                        setCarrito(carrito.map(i=>i.cartItemId===item.cartItemId?{...i, cantidad:n, subtotal:n*i.precioOriginal}:i));
                                                    }}
                                                />
                                                <button className="btn btn-white border" onClick={()=>setCarrito(carrito.map(i=>i.cartItemId===item.cartItemId?{...i, cantidad:i.cantidad+1, subtotal:(i.cantidad+1)*i.precioOriginal}:i))}>+</button>
                                            </div>
                                            <div className="fw-bold">Bs. {(item.subtotal + (esPedidosYa ? item.cantidad * 10 : 0)).toFixed(2)}</div>
                                            <button className="btn btn-sm text-danger" onClick={()=>setCarrito(carrito.filter(i=>i.cartItemId!==item.cartItemId))}><FaTrash/></button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="p-3 border-top">
<button className="btn btn-outline-primary btn-sm w-100 mb-2 fw-bold" onClick={handleAplicarDescuento}><FaGift/> DESCUENTO / PUNTOS</button>
                            <button className="btn btn-outline-success btn-sm w-100 mb-2 fw-bold" onClick={()=>setShowFactura(true)}><FaFileInvoice/> FACTURA</button>
                            <div className="d-flex justify-content-between fs-4 fw-bold mb-3"><span>TOTAL</span><span>Bs. {calcularTotal().toFixed(2)}</span></div>
                            <button className="btn btn-lg w-100 py-3 fw-bold rounded-pill text-white shadow" onClick={()=>setShowPago(true)} disabled={carrito.length===0} style={{background: currentSucursal.primary}}>COBRAR</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL PRODUCTO WIZARD */}
            {showModalProducto && prodSeleccionado && (
                <div className="modal d-block" style={{backgroundColor: 'rgba(0,0,0,0.8)'}}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg" style={{borderRadius: '24px'}}>
                            <div className="modal-header border-0"><h5 className="fw-bold m-0">{prodSeleccionado.nombre} {prodSeleccionado.nombre.includes('Mixta') && `- Paso ${stepMixta}`}</h5><button className="btn-close" onClick={()=>setShowModalProducto(false)}></button></div>
                            <div className="modal-body p-4 pt-0">
                                {stepMixta === 1 && (
                                    <>
                                        {prodSeleccionado.nombre.toLowerCase().includes('mixta') && (
                                            <div className="mb-3">
                                                <label className="fw-bold text-primary small">SELECCIONE MILANESA 1:</label>
                                                <select className="form-select" onChange={async (e)=>{ setM1Seleccionada(e.target.value); const p = productos.find(x=>x.nombre===e.target.value); if(p){const r=await axios.get(`${API_URL}/recetas/${p.id}`);setM1Receta(r.data);}}}>
                                                    <option value="">-- Seleccionar --</option>
                                                    {productos.filter(p=>p.nombre.toLowerCase().includes('milanesa') && !p.nombre.toLowerCase().includes('mixta')).map(m=><option key={m.id} value={m.nombre}>{m.nombre}</option>)}
                                                </select>
                                            </div>
                                        )}
                                        {prodSeleccionado.nombre.toLowerCase().includes('milanesa') && !prodSeleccionado.nombre.toLowerCase().includes('mixta') && (
                                            <div className="mb-3">
                                                <label className="fw-bold small text-primary">📋 INGREDIENTES QUE NO QUIERA INCLUIR:</label>
                                                <div className="alert alert-light border-2 border-primary p-3">
                                                    <div className="row g-2">
                                                        {recetaActual.length > 0 ? recetaActual.map((ing, idx) => (
                                                            <div key={idx} className="col-12">
                                                                <button onClick={()=>setIngredientesExcluidos(ingredientesExcluidos.includes(ing.insumo_id)?ingredientesExcluidos.filter(i=>i!==ing.insumo_id):[...ingredientesExcluidos, ing.insumo_id])} className={`btn w-100 py-2 ${ingredientesExcluidos.includes(ing.insumo_id)?'btn-danger':'btn-outline-success'}`}>
                                                                    <span className="fw-bold">{ing.nombre_insumo}</span>
                                                                </button>
                                                            </div>
                                                        )) : <div className="col-12 text-center text-muted"><small>Sin ingredientes</small></div>}
                                                    </div>
                                                </div>
                                                <label className="fw-bold small mt-2 d-block">OBSERVACIONES:</label>
                                                <textarea className="form-control" rows="2" value={observacionProducto} onChange={e=>setObservacionProducto(e.target.value)}></textarea>
                                            </div>
                                        )}
                                        {!prodSeleccionado.nombre.toLowerCase().includes('mixta') && !prodSeleccionado.nombre.toLowerCase().includes('milanesa') && (
                                            <div className="mb-3"><label className="fw-bold small">OBSERVACIONES:</label><textarea className="form-control" rows="2" value={observacionProducto} onChange={e=>setObservacionProducto(e.target.value)}></textarea></div>
                                        )}
                                        <button className="btn btn-primary w-100 py-3 rounded-pill fw-bold shadow" onClick={()=>{
                                            if(prodSeleccionado.nombre.toLowerCase().includes('mixta')){
                                                if(!m1Seleccionada) return Swal.fire('Atención','Elige la primera milanesa','warning');
                                                setStepMixta(2);
                                            } else { confirmarAgregarProducto(); }
                                        }}>{prodSeleccionado.nombre.includes('Mixta') ? <>SIGUIENTE <FaArrowRight/></> : 'AGREGAR'}</button>
                                    </>
                                )}
                                {stepMixta === 2 && (
                                    <>
                                        <div className="mb-3">
                                            <label className="fw-bold text-primary small">SELECCIONE MILANESA 2:</label>
                                            <select className="form-select" onChange={async (e)=>{ setM2Seleccionada(e.target.value); const p = productos.find(x=>x.nombre===e.target.value); if(p){const r=await axios.get(`${API_URL}/recetas/${p.id}`);setM2Receta(r.data);}}}>
                                                <option value="">-- Seleccionar --</option>
                                                {productos.filter(p=>p.nombre.toLowerCase().includes('milanesa') && !p.nombre.toLowerCase().includes('mixta')).map(m=><option key={m.id} value={m.nombre}>{m.nombre}</option>)}
                                            </select>
                                        </div>
                                        <button className="btn btn-primary w-100 py-3 rounded-pill fw-bold shadow" onClick={()=>{ if(!m2Seleccionada) return Swal.fire('Atención','Elige la milanesa 2','warning'); setStepMixta(3); }}>SIGUIENTE <FaArrowRight/></button>
                                    </>
                                )}
                                {stepMixta === 3 && (
                                    <>
                                        <div className="mb-3"><label className="fw-bold small">OBSERVACIONES FINALES:</label><textarea className="form-control" rows="2" value={observacionProducto} onChange={e=>setObservacionProducto(e.target.value)}></textarea></div>
                                        <div className="mb-3">
                                            <label className="fw-bold small text-primary">📋 INGREDIENTES QUE NO QUIERA INCLUIR (UNIFICADOS):</label>
                                            <div className="alert alert-light border-2 border-primary p-3">
                                                {(() => {
                                                    const map = {};
                                                    m1Receta.forEach(ing => {
                                                        if (!map[ing.insumo_id]) map[ing.insumo_id] = { ...ing, enM1: false, enM2: false };
                                                        map[ing.insumo_id].enM1 = true;
                                                    });
                                                    m2Receta.forEach(ing => {
                                                        if (!map[ing.insumo_id]) map[ing.insumo_id] = { ...ing, enM1: false, enM2: false };
                                                        map[ing.insumo_id].enM2 = true;
                                                    });
                                                    const ingredientes = Object.values(map);
                                                    const toggleExcluido = (ing) => {
                                                        if (ing.enM1) {
                                                            setM1Excluidos(m1Excluidos.includes(ing.insumo_id) ? m1Excluidos.filter(i=>i!==ing.insumo_id) : [...m1Excluidos, ing.insumo_id]);
                                                        }
                                                        if (ing.enM2) {
                                                            setM2Excluidos(m2Excluidos.includes(ing.insumo_id) ? m2Excluidos.filter(i=>i!==ing.insumo_id) : [...m2Excluidos, ing.insumo_id]);
                                                        }
                                                    };
                                                    const estaExcluido = (ing) => (ing.enM1 && m1Excluidos.includes(ing.insumo_id)) || (ing.enM2 && m2Excluidos.includes(ing.insumo_id));
                                                    return (
                                                        <div className="row g-2">
                                                            {ingredientes.length > 0 ? ingredientes.map((ing, idx) => (
                                                                <div key={idx} className="col-12">
                                                                    <button onClick={()=>toggleExcluido(ing)} className={`btn w-100 py-2 ${estaExcluido(ing)?'btn-danger':'btn-outline-success'}`}>
                                                                        <span className="fw-bold">{ing.nombre_insumo}</span>
                                                                    </button>
                                                                </div>
                                                            )) : <div className="col-12 text-center text-muted"><small>Sin ingredientes</small></div>}
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                        <button className="btn btn-success w-100 py-3 rounded-pill fw-bold shadow" onClick={confirmarAgregarProducto}>LISTO - AGREGAR</button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
{/* MODAL FACTURA */}
            {showFactura && (
                <div className="modal d-block" style={{backgroundColor:'rgba(0,0,0,0.8)'}}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg" style={{borderRadius:'20px'}}>
                            <div className="modal-header border-0 pb-0">
                                <h5 className="fw-bold m-0"><FaFileInvoice className="me-2"/>Datos de Factura</h5>
                                <button className="btn-close" onClick={()=>setShowFactura(false)}></button>
                            </div>
                            <div className="modal-body p-4">
                                <div className="mb-3">
                                    <label className="small fw-bold text-muted mb-2">RAZÓN SOCIAL / NOMBRE</label>
                                    <input 
                                        type="text" 
                                        className="form-control form-control-lg shadow-sm" 
                                        placeholder="Ej: Juan Pérez"
                                        value={facturaData.razon_social}
                                        onChange={(e)=>setFacturaData({...facturaData, razon_social: e.target.value})}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="small fw-bold text-muted mb-2">NIT / CI</label>
                                    <input 
                                        type="text" 
                                        className="form-control form-control-lg shadow-sm" 
                                        placeholder="Ej: 1234567"
                                        value={facturaData.nit}
                                        onChange={(e)=>setFacturaData({...facturaData, nit: e.target.value})}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer border-0 pt-0">
                                <button className="btn btn-success btn-lg w-100 py-3 fw-bold rounded-pill shadow" onClick={()=>setShowFactura(false)}>
                                    GUARDAR DATOS
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL COBRO */}
            {showPago && (
                <div className="modal d-block" style={{backgroundColor:'rgba(0,0,0,0.9)'}}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg" style={{borderRadius:'24px', overflow:'hidden'}}>
                            <div className="p-4 text-white text-center" style={{background: currentSucursal.color}}><h3 className="m-0 fw-bold">Bs. {calcularTotal().toFixed(2)}</h3></div>
                            <div className="modal-body p-4">
                                <div className="card bg-light border-0 p-3 mb-3">
                                    <label className="small fw-bold text-muted mb-2">DATOS DEL CLIENTE</label>
                                    <input className="form-control mb-2" name="cliente_nombre_venta" autoComplete="off" placeholder="Nombre..." value={cliente.nombre} onChange={(e)=>{
                                        setCliente({...cliente, nombre: e.target.value});
                                        const f = clientesDb.find(c=>c.nombre.toLowerCase()===e.target.value.toLowerCase());
                                        if(f){ setClienteIdDb(f.id); setCliente({nombre:f.nombre, telefono:f.telefono||''}); }
                                    }}/>
                                    {(() => {
                                        const term = (cliente.nombre || '').trim().toLowerCase();
                                        if (term.length < 2) return null;
                                        if (clientesDb.some(c => c.nombre.toLowerCase() === term)) return null;
                                        const sugeridos = clientesDb.filter(c => c.nombre.toLowerCase().includes(term)).slice(0, 2);
                                        if (sugeridos.length === 0) return null;
                                        return (
                                            <div className="mb-2">
                                                {sugeridos.map(c => (
                                                    <button
                                                        key={c.id}
                                                        type="button"
                                                        className="btn btn-outline-secondary btn-sm w-100 text-start py-1 mb-1"
                                                        onClick={() => { setClienteIdDb(c.id); setCliente({nombre: c.nombre, telefono: c.telefono || ''}); }}
                                                    >
                                                        <span className="fw-bold">{c.nombre}</span>
                                                        {c.telefono ? <small className="text-muted ms-2">{c.telefono}</small> : null}
                                                    </button>
                                                ))}
                                            </div>
                                        );
                                    })()}
                                    <input className="form-control" name="cliente_whatsapp_venta" autoComplete="off" placeholder="WhatsApp..." value={cliente.telefono} onChange={e=>setCliente({...cliente, telefono: e.target.value})}/>
                                </div>
                                <div className="btn-group w-100 mb-3">
                                    <button className={`btn ${tipoPago==='efectivo'?'btn-primary':'btn-outline-secondary'}`} onClick={()=>setTipoPago('efectivo')}>Efectivo</button>
                                    <button className={`btn ${tipoPago==='qr'?'btn-primary':'btn-outline-secondary'}`} onClick={()=>setTipoPago('qr')}>QR</button>
                                    <button className={`btn ${tipoPago==='mixto'?'btn-primary':'btn-outline-secondary'}`} onClick={()=>setTipoPago('mixto')}>Mixto</button>
                                </div>
                                {tipoPago !== 'qr' && <input type="number" className="form-control form-control-lg mb-2 shadow-sm" placeholder="Efectivo recibido..." value={montoEfectivo} onChange={e=>setMontoEfectivo(e.target.value)}/>}
                                {tipoPago === 'mixto' && <input type="number" className="form-control form-control-lg mb-2 shadow-sm" placeholder="Monto QR..." value={montoQR} onChange={e=>setMontoQR(e.target.value)}/>}
                                {tipoPago !== 'qr' && <div className="alert alert-info text-center py-1 small">Cambio: <strong>Bs. {cambio.toFixed(2)}</strong></div>}
                            </div>
                            <div className="modal-footer border-0 p-4 pt-0">
                                <button className="btn btn-lg w-100 py-3 fw-bold rounded-pill text-white shadow" onClick={handleFinalizarVenta} style={{background: currentSucursal.primary}}>FINALIZAR VENTA</button>
                                <button className="btn btn-link w-100 text-muted" onClick={()=>setShowPago(false)}>Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL PENDIENTES */}
            {showEntregar && (
                <div className="modal d-block" style={{backgroundColor:'rgba(0,0,0,0.8)'}}>
                    <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                        <div className="modal-content border-0 shadow-lg" style={{borderRadius: '20px'}}>
                            <div className="modal-header bg-warning text-dark border-0"><h5 className="fw-bold m-0">Pendientes de Entrega</h5><button className="btn-close" onClick={()=>setShowEntregar(false)}></button></div>
                            <div className="modal-body p-0">
                                {pedidosPendientes.length === 0 ? <div className="p-5 text-center text-muted">No hay pedidos por entregar</div> : (
                                    <div className="list-group list-group-flush">
                                        {pedidosPendientes.map(p => (
                                            <div key={p.id} className="list-group-item p-3 d-flex justify-content-between align-items-center">
                                                <div><div className="fw-bold">Ticket #{p.id} - {p.cliente_nombre || 'S/N'}</div><small className="text-muted">{p.metodo_pago}</small></div>
                                                <button className="btn btn-success btn-sm rounded-pill px-4 fw-bold shadow-sm" onClick={async ()=>{
                                                    try {
                                                        await axios.post(`${API_URL}/monitor/cambiar-estado`, { id: p.id, estado: 'entregado' });
                                                        fetchPedidosPendientes();
                                                        Swal.fire({ icon: 'success', title: 'Entregado', timer: 1000, showConfirmButton: false });
                                                    } catch (e) { Swal.fire('Error', 'No se pudo entregar', 'error'); }
                                                }}>ENTREGAR</button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
